var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tw-mt-1 tw-w-full bg-col-orange f-h-40 tw-flex tw-justify-center tw-items-center border-rounded-10"},[_c('span',{staticClass:"tx-col-black tw-font-semibold tw-px-4 tw-py-2 md:tw-py-1"},[_vm._v("Your account doesn't have the required permissions to edit this resource")])])
}]

export { render, staticRenderFns }